import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const CustomButton = ({
    buttonColor = '#FFFFFF',
    margin,
    borderColor = '#D0D5DD',
    title = '',
    titleColor = '#000000',
    icon = null,
    handleClick = () => {},
    tailIcon = null,
    customStyle = {},
    type = 'button',
    buttonDisabled = false,
    data_test_id
}) => (
    <Button
        data-testid={data_test_id}
        disabled={buttonDisabled}
        endIcon={tailIcon}
        startIcon={icon}
        sx={{
            height: '40px',
            background: buttonColor,
            color: titleColor,
            padding: '0px 16px',
            borderRadius: '20px',
            textTransform: 'none',
            margin: margin,
            border: `1px solid ${borderColor}`,
            '&:hover': { backgroundColor: buttonColor },
            ...customStyle
        }}
        type={type}
        onClick={handleClick}
    >
        {title}
    </Button>
);

CustomButton.propTypes = {
    buttonColor: PropTypes.string,
    margin: PropTypes.string,
    borderColor: PropTypes.string,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    icon: PropTypes.node,
    handleClick: PropTypes.func,
    tailIcon: PropTypes.node,
    customStyle: PropTypes.object,
    type: PropTypes.string,
    buttonDisabled: PropTypes.bool,
    data_test_id: PropTypes.string
};

export default CustomButton;
